// @ts-expect-error not migrated to TS yet
import AbOptionSelect from 'EmailComponents/emailCreation/AbOptionSelect';
import { getBuNameById } from 'EmailComponents/utils/businessUnit';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UIFormControl from 'UIComponents/form/UIFormControl';
import UITextInput from 'UIComponents/input/UITextInput';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import BusinessUnitSelect from 'ui-business-units-lib/components/BusinessUnitSelect';
import { useHasBusinessUnitsRebrand } from 'ui-business-units-lib/hooks/useHasBusinessUnitsRebrand';
import { Text } from 'foundations-components/components/Text';
import { View } from 'foundations-components/transitional/components/View';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function AbLikeEmailCloneBody({
  buOptions,
  content,
  emailBusinessUnitId,
  emailName,
  emailDetails,
  onCancel,
  handleTextChange,
  isEmailEligibleForBUDropDown,
  isBusinessUnitSelected,
  isAccountSelected,
  cloneEmailName,
  onClone,
  onSelectBusinessUnit,
  overrideABCloneOption,
  overrideCloneOptions
}) {
  const isCloneDisabledDueToBU = isEmailEligibleForBUDropDown && !isBusinessUnitSelected && !isAccountSelected;
  const isCloneDisabledForABEmail = content && content.isABLike() && !overrideABCloneOption;
  const isCloneDisabled = isCloneDisabledDueToBU || cloneEmailName === '' || isCloneDisabledForABEmail;
  const hasBusinessUnitsRebrand = useHasBusinessUnitsRebrand();
  const disabledTooltip = isCloneDisabledForABEmail ? 'EmailComponents.modals.clone.abDisabled' : isCloneDisabledDueToBU ? hasBusinessUnitsRebrand ? 'EmailComponents.modals.clone.buDisabledRss_buv2' : 'EmailComponents.modals.clone.buDisabledRss' : 'EmailComponents.modals.clone.nameDisabled';
  const maybeRenderAbCloneOptions = () => {
    if (emailDetails && !emailDetails.isEmpty() && content && content.isABLike()) {
      return /*#__PURE__*/_jsx(AbOptionSelect, {
        emailDetails: emailDetails,
        overrideCloneOptions: overrideCloneOptions
      });
    } else {
      return null;
    }
  };
  return /*#__PURE__*/_jsxs(View, {
    inlineSize: "440px",
    marginInlineStart: "1400",
    "data-test-id": "ab-email-clone-body",
    children: [/*#__PURE__*/_jsxs(UIFlex, {
      align: "stretch",
      justify: "center",
      direction: "column",
      children: [isEmailEligibleForBUDropDown && /*#__PURE__*/_jsx(Text, {
        marginBlockEnd: "200",
        children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
          "data-test-id": "email-cross-clone-bu-info",
          message: "EmailComponents.modals.businessUnit.originalEmailBUInfo",
          options: {
            emailName,
            buName: getBuNameById(emailBusinessUnitId, buOptions)
          }
        })
      }), isEmailEligibleForBUDropDown && /*#__PURE__*/_jsx(BusinessUnitSelect, {
        buOptions: buOptions,
        withHeader: true,
        onChange: onSelectBusinessUnit
      }), /*#__PURE__*/_jsx(UIFormControl, {
        label: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.modals.clone.body"
        }),
        children: /*#__PURE__*/_jsx(UITextInput, {
          onChange: handleTextChange,
          value: cloneEmailName
        })
      }), maybeRenderAbCloneOptions()]
    }), /*#__PURE__*/_jsxs(View, {
      paddingBlockStart: "600",
      paddingBlockEnd: "600",
      as: "div",
      children: [/*#__PURE__*/_jsx(UITooltip, {
        disabled: !isCloneDisabled,
        title: /*#__PURE__*/_jsx(FormattedMessage, {
          message: disabledTooltip
        }),
        children: /*#__PURE__*/_jsx(UIButton, {
          "data-test-id": "ab-clone-confirmation",
          disabled: isCloneDisabled,
          onClick: onClone,
          use: "primary",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "EmailComponents.modals.clone.cloneButton"
          })
        })
      }), /*#__PURE__*/_jsx(UIButton, {
        "data-selenium": "clone-modal-cancel",
        onClick: onCancel,
        use: "secondary",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "EmailComponents.modals.clone.cancel"
        })
      })]
    })]
  });
}
export default AbLikeEmailCloneBody;